import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { RubrikConfigEntry } from '../../../../core/base-api';
import { RubrikConfigService } from '../rubrik-config.service';
import RubrikEnum = RubrikConfigEntry.RubrikEnum;

@Injectable()
export class GrundstueckConfigResolver {
  constructor(private rubrikService: RubrikConfigService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<[RubrikConfigEntry, string[]]> {
    return this.rubrikService.loadConfigs(RubrikEnum.GB_DETAIL_GRUNDSTUECK);
  }
}
